<div class="sidebar-footer__bottom-line"></div>
<div class="support-panel__header">
    <span class="support-panel__title">Need more help?</span>
    <a class="support-panel__button" href="mailto:taap@mercer.com">
        <span class="support-panel__button-text">Contact TAAP Team</span>
    </a>
    <button class="support-panel__button support-panel__button--expert" (click)="goToConsultant()">
        <span class="support-panel__button-text">Ask an Expert</span>
    </button>
</div>
<div class="sidebar-footer__bottom-line"></div>
<div class="sidebar-footer">
    <div class="sidebar-footer__user" *ngIf="(loggedIn$ | async) === true"></div>
    <mapp-dropdown-profile
        [userData]="userData"
        [initialText]="initials"
        [dropdownPosition]="'right'"
        (logout)="logout()"
    >
    </mapp-dropdown-profile>
    <span class="sidebar-footer__user__name">
        {{ userData?.firstName }} {{ userData?.lastName }}
    </span>
    <button
        *ngIf="isAdminUser"
        class="sidebar-footer__admin-link sidebar-footer__admin-compact"
        routerLink="/aida/admin/dashboard"
        aria-label="Admin Dashboard"
        [aidaTooltip]="'Admin Dashboard'"
    >
        <img
            class="sidebar-footer__admin-icon"
            src="/assets/icons/admin-dashboard.svg"
            alt="Admin Dashboard"
        />
    </button>
    <!-- Tooltip is now handled by AidaTooltipDirective -->
</div>
<div class="sidebar-footer__bottom-line"></div>
<div class="support-panel">
    <div class="support-panel__links">
        <div class="support-panel__row">
            <a
                href="https://taap.mercer.com/Portals/0/content/Resource/terms-of-use.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="support-panel__link"
                >Terms of Use</a
            >
            <span class="support-panel__separator">|</span>
            <a
                href="https://taap.mercer.com/Portals/0/content/Resource/privacy-notice.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="support-panel__link"
                >Privacy Notice</a
            >
            <span class="support-panel__separator">|</span>
            <a
                href="https://www.mercer.com/footer/mercer-accessibility-statement/"
                target="_blank"
                rel="noopener noreferrer"
                class="support-panel__link"
                >Accessibility</a
            >
        </div>
        <div class="support-panel__row">
            <a [href]="siteMapUrl" class="support-panel__link">Site Map</a>
            <span class="support-panel__separator">|</span>
            <a
                href="https://www.mercer.com/regulatory/mercer-cookie-notice/"
                target="_blank"
                rel="noopener noreferrer"
                class="support-panel__link"
                >Cookie Notice</a
            >
            <span class="support-panel__separator">|</span>
            <!-- TrustArc mount point; visually hidden, clicked by the button below -->
            <span id="teconsent" aria-hidden="true"></span>
            <button
                type="button"
                class="support-panel__link support-panel__manage-cookies"
                (click)="openCookiePreferences()"
            >
                Manage Cookies
            </button>
        </div>
    </div>
</div>
<div class="sidebar-footer__brand__footer">
    <img src="/assets/icons/logo-marsh-white.svg" alt="Marsh" />
    <p>© {{ actualYear }} Marsh. All rights reserved.</p>
</div>
